import { axiosInstance } from '../../api/api';

/**
 * Fetch the list of vehicles eligible for the SFLT screen
 * @param {function} successCallback
 * @param {function} errorCallback
 */
export const fetchSFLTVehicles = (successCallback, errorCallback) => () => {
	axiosInstance
		.get('/station/sflt/vehicles')
		.then(({ data }) => {
			successCallback(data);
		})
		.catch((err) => {
			errorCallback(err);
		});
};

/**
 * Receive the selected vehicle before marking SFLT
 * @param {string} asn
 * @param {function} successCallback
 * @param {function} errorCallback
 */
export const receiveSFLTVehicle = (vin, successCallback, errorCallback) => () => {
	axiosInstance
		.post(`/station/receive/${vin}`)
		.then(({ data }) => {
			successCallback(data);
		})
		.catch((err) => {
			errorCallback(err);
		});
};

/**
 * Complete SFLT operation
 * @param {string} asn
 * @param {function} successCallback
 * @param {function} errorCallback
 */
export const completeSFLT = (asn, successCallback, errorCallback) => {
	return () => {
		axiosInstance
			.post(`/station/sflt/${asn}`)
			.then(({ data }) => {
				successCallback(data);
			})
			.catch((err) => {
				errorCallback(err);
			});
	};
};
